export default {
  materia: [
    {
      titulo: "CAPA",
      resumo: "Moda e sustentabilidade em pauta: consumidor no centro",
      imgAutor: require("../assets/imgs/autores/juliana.helena.png"),
      nomeAutor: "Helena Canhoni e Júlia Rondinelli",
      cargoAutor: "E-Commerce Brasil",
      conteudo:
        "O mercado de moda enfrenta constantes desafios entre consumo crescente e sustentabilidade. Tal dilema inclui a crise percebida na indústria, com altos preços, dificuldades financeiras e crescimento do setor. Somando a tudo isso as preocupações sobre a preservação do planeta, a moda circular surge como tendência, uma vez que busca reduzir desperdícios e prolongar a vida útil das roupas. Tanto a influência da geração Z, como o crescimento do comércio social e a experiência do consumidor destacam-se nesse universo — e o 'greenwashing' acende o alerta para a importância de práticas genuinamente sustentáveis. Saiba por que o futuro do mercado depende da adaptação às mudanças e quais são as expectativas do consumidor. ",
      tempLeitura: "2",
      imgMateria: require("../assets/imgs/imgs_79/500x500px-CAPA.png"),
      active: true,
      viewModal: false,
    },
    {
      titulo: "ENTREVISTA",
      resumo: "Os dois lados da mesma viagem",
      imgAutor: require("../assets/imgs/autores/amanda.png"),
      nomeAutor: "Amanda Lucio",
      cargoAutor: "E-Commerce Brasil",
      conteudo:
        "Fundada em 2013, a ClickBus transformou a venda de passagens de ônibus ao digitalizar um mercado onde apenas 2% eram vendidas online. Após 10 anos e 51 milhões de viajantes, a plataforma busca ser referência no setor, investindo em tecnologia, personalização e parcerias B2B. Com uma série de desafios na transição, a empresa incentiva a compra online e destaca a redescoberta do ônibus como meio seguro e confortável. Para o CEO da empresa, Phillip Klien, há um futuro muito promissor com a digitalização contínua, novas rodoviárias e integração intermodal. ",
      tempLeitura: "2",
      imgMateria: require("../assets/imgs/imgs_79/500x500px-ENTREVISTA.png"),
      active: true,
      viewModal: false,
    },
    {
      titulo: "CASE",
      resumo: "Beleza orgânica",
      imgAutor: require("../assets/imgs/autores/giuliano.kina.png"),
      nomeAutor: "Giuliano Gonçalves e Lucas Kina",
      cargoAutor: "E-Commerce Brasil",
      conteudo:
        "Por conta de algumas questões pessoais, Milly Arazi Spatz, artista plástica, mudou seu estilo de vida e iniciou o cultivo de alimentos orgânicos. Muito além disso, ela transformou a atividade em negócio — hoje, age como intermediária entre produtores e consumidores da grande São Paulo com a “Do Mato Pra Casa”. Como nem tudo são flores, na pandemia seu negócio prosperou, mas enfrentou desafios no pós-pandemia, levando-a a uma redução de escala e a retornar para a capital de SP. A sustentabilidade da empresa é tema central, com embalagens biodegradáveis e doação de excedentes. Acompanhe essa história sobre adaptação ao mercado de orgânicos e valores genuínos, como respeito à natureza e solidariedade.",
      tempLeitura: "2",
      imgMateria: require("../assets/imgs/imgs_79/500x500px.png"),
      active: true,
      viewModal: false,
    },
  ],
};
